<template>
<div class="container" id="containergeneral">
<div class="row">
  <div class="col-75">
    <div class="containercard">
      <form @submit.prevent="createToken()">

        <div class="row">
          <div class="col-50">
            <h3>Dirección de Envío</h3>
            <br>
            <label for="fname"><i class="fa fa-user"></i> Nombre Completo</label>
            <input type="text" id="fname" name="firstname" placeholder="John M. Doe">

            <label for="email"><i class="fa fa-envelope"></i> Email</label>
            <input type="text" id="card[email]" data-culqi="card[email]" name="email" placeholder="john@example.com">

            <label for="adr"><i class="fa fa-address-card-o"></i> Dirección</label>
            <input type="text" id="adr" name="address" placeholder="542 W. 15th Street">

            <label for="city"><i class="fa fa-institution"></i> Ciudad</label>
            <input type="text" id="city" name="city" placeholder="New York">

            <div class="row">
              <div class="col-50">
                <label for="state">State</label>
                <input type="text" id="state" name="state" placeholder="NY">
              </div>
              <div class="col-50">
                <label for="zip">Zip</label>
                <input type="text" id="zip" name="zip" placeholder="10001">
              </div>
            </div>
          </div>

          <div class="col-50">
            <h3>Información de Pago</h3>
            <br>
            <label for="fname">Tarjetas Aceptadas</label>
            <div class="icon-container">
              <i class="fa fa-cc-visa" style="color:navy;"></i>&nbsp;
              <i class="fa fa-cc-amex" style="color:blue;"></i>&nbsp;
              <i class="fa fa-cc-mastercard" style="color:red;"></i>&nbsp;
              <i class="fa fa-cc-discover" style="color:orange;"></i>
            </div>

            <label for="cname">Nombre de Tarjeta</label>
            <input type="text" id="cname" name="cardname" placeholder="John More Doe">

            <label for="ccnum">Número de Tarjeta</label>
            <input type="text" id="card[number]" data-culqi="card[number]" name="cardnumber" placeholder="1111-2222-3333-4444">

            <div class="row">
              <div class="col-25">
                <label for="expmonth">Exp Month</label>
                <input type="text" id="card[exp_month]" data-culqi="card[exp_month]" name="expyear" placeholder="2020">
              </div>
              <div class="col-50">
                <label for="cvv">Exp Year</label>
                <input type="text" id="card[exp_year]" data-culqi="card[exp_year]" placeholder="2020">
              </div>
            </div>
            <label for="cvv">CVV</label>
            <input type="text" size="3" id="card[cvv]" data-culqi="card[cvv]" name="cvv" placeholder="123">
          </div>
        </div>

        <label>
        <input type="checkbox" checked="checked" name="sameadr"> Shipping address same as billing
        </label>
        <input type="submit" value="Pagar" class="btncard">
      </form>
    </div>
  </div>

  <div class="col-25">
    <div class="containercard">
      <h4>Cart 
        <span class="price" style="color:black">
          <i class="fa fa-shopping-cart"></i> 
          <b> 4</b>
        </span>
      </h4>
      <p><a href="#">Product 1</a> <span class="price">$15</span></p>
      <p><a href="#">Product 2</a> <span class="price">$5</span></p>
      <p><a href="#">Product 3</a> <span class="price">$8</span></p>
      <p><a href="#">Product 4</a> <span class="price">$2</span></p>
      <hr>
      <p>Total <span class="price" style="color:black"><b>$30</b></span></p>
    </div>
  </div>
</div>
</div>
</template>
<script>
  Culqi.publicKey = 'pk_test_cZJm1j7hvWp5lmPt';
  Culqi.init();
</script>

<script>

export default {
  name: "checkoutPayment",
  data() {
    return {
      totalValue: 12,
      name_product_es: Array()
    };
  },
  methods: {
    initCulqi(){
    },
    createToken(){
       Culqi.createToken();
    },
    /*
    culqi: function(){
      if (Culqi.token) { // ¡Objeto Token creado exitosamente!
        var token = Culqi.token.id;
        alert('Se ha creado un token:' + token);
      } 
      else { // ¡Hubo algún problema!
      // Mostramos JSON de objeto error en consola
        console.log(Culqi.error);
        alert(Culqi.error.user_message);
      }
    }
    */
  },
  mounted() {
      this.initCulqi();
  }
};
</script>

<style>
p{
    text-align: left;
}

h3{
    text-align: left
}

#containergeneral {
    margin-top: 140px;
    margin-bottom: 30px;
}

.row {
  display: -ms-flexbox; /* IE10 */
  display: flex;
  -ms-flex-wrap: wrap; /* IE10 */
  flex-wrap: wrap;
  margin: 0 -16px;
}

.col-25 {
  -ms-flex: 25%; /* IE10 */
  flex: 25%;
}

.col-50 {
  -ms-flex: 50%; /* IE10 */
  flex: 50%;
}

.col-75 {
  -ms-flex: 75%; /* IE10 */
  flex: 75%;
}

.col-25,
.col-50,
.col-75 {
  padding: 0 16px;
}

.containercard {
  background-color: #f2f2f2;
  padding: 5px 20px 15px 20px;
  border: 1px solid lightgrey;
  border-radius: 3px;
}

input[type=text] {
  width: 100%;
  margin-bottom: 20px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

label {
  margin-bottom: 10px;
  display: block;
  text-align: left;
}

.icon-container {
  margin-bottom: 20px;
  padding: 7px 0;
  font-size: 24px;
  text-align: left;
}

.btncard {
  background-color: #4CAF50;
  color: white;
  padding: 12px;
  margin: 10px 0;
  border: none;
  width: 100%;
  border-radius: 3px;
  cursor: pointer;
  font-size: 17px;
}

.btncard:hover {
  background-color: #45a049;
}

span.price {
  float: right;
  color: grey;
}

/* Responsive layout - when the screen is less than 800px wide, make the two columns stack on top of each other instead of next to each other (and change the direction - make the "cart" column go on top) */
@media (max-width: 800px) {
  .row {
    flex-direction: column-reverse;
  }
  .col-25 {
    margin-bottom: 20px;
  }
}
</style>
